import React from "react"
import classNames from "classnames"

const LofiBrowserFrame = ({ darkMode = false, className, children }) => {
  return (
    <span
      className={classNames(darkMode && "dark")}
      data-testid="lofi-browser-frame"
    >
      <div
        className={classNames(
          "mt-6 flex flex-col grow mx-4 border rounded-t rounded-r min-h-[100px] bg-background dark:bg-dark dark:border-secondary-500",
          className
        )}
      >
        <div className="flex gap-1 p-1 border-b dark:border-secondary-500">
          <div className="w-1.5 h-1.5 rounded-full bg-error-500 dark:bg-error-600" />
          <div className="w-1.5 h-1.5 rounded-full bg-warning-300 dark:bg-warning-400" />
          <div className="w-1.5 h-1.5 rounded-full bg-success" />
        </div>
        <div className="grid flex-1 min-h-24 dark:text-white">{children}</div>
      </div>
    </span>
  )
}

export default LofiBrowserFrame
